module.exports = __webpack_public_path__ + "img/double_plug_box2.16237cb5.png";